module.exports = __webpack_public_path__ + "static/img/project_1_old.90dee56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/project_1_old.jpg
// module id = o7ru
// module chunks = 0